import { render } from "./sellInvoiceAdd.vue?vue&type=template&id=1abf8fab&scoped=true"
import script from "./sellInvoiceAdd.vue?vue&type=script&lang=js"
export * from "./sellInvoiceAdd.vue?vue&type=script&lang=js"

import "./sellInvoiceAdd.vue?vue&type=style&index=0&id=1abf8fab&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abf8fab"]])

export default __exports__